<template>
    <Table :pagination="false" stripe :tableData="detailsData">
        <template v-slot:head>
            <vs-th sort-key="name">{{i('global.Advertisers')}}</vs-th>
            <vs-th sort-key="advertiser_leads_total" class="column__data">{{i('global.Leads')}}</vs-th>
            <vs-th sort-key="amount_leads_by_advertiser" class="column__data">{{i('global.Total')}}</vs-th>
            <vs-th sort-key="conversion" class="column__data">%</vs-th>
        </template>

        <template v-slot:content="{content}">
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.name}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.advertiser_leads_total}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.amount_leads_by_advertiser}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{Number(content.conversion).toFixed(2)}}</p>
            </vs-td>
        </template>
    </Table>
</template>

<script>
import Table from '@/components/custom-table/Table'
import i18n from '@/i18n/i18n'
export default {
    props: {
        detailsData: {
            type: Array,
            default() {
                return []
            }
        }
    },

    components: {
        Table
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        }
    }
}
</script>